/* eslint-disable no-underscore-dangle */
import { useEffect } from 'react';
import mountSuperPhoebeWidget from './superPhoebeWidget';
import useChatbotProvider from './useChatbotProvider';
import logger from '../../utils/logger';
import getAdobeVisitorContext from './adobeVisitorContext';

const SuperPhoebeIntegration = () => {
  const chatbotProvider = useChatbotProvider();
  const {
    REACT_APP_SUPER_PHOEBE_SCRIPT_URL: scriptUrl,
    REACT_APP_SUPER_PHOEBE_BACKEND_URL: backendUrl,
    REACT_APP_ENV: environment,
  } = window.__ENV || {};

  useEffect(() => {
    if (chatbotProvider !== 'super-phoebe') return undefined;
    const onError = () => logger.warn('Super Phoebe widget could not be loaded.');
    try {
      return mountSuperPhoebeWidget({
        scriptUrl,
        backendUrl,
        localOverride: environment === 'local' || environment === 'dev',
        onError,
        visitorContextProvider: getAdobeVisitorContext,
      });
    } catch {
      onError();
      return undefined;
    }
  }, [chatbotProvider, scriptUrl, backendUrl, environment]);

  return null;
};

export default SuperPhoebeIntegration;
